(function () {
  'use strict';

  angular
    .module('app.page-project-part-types', []);
})();
